var map = {
	"./fred-renteria-always-happy-to-help.json": 2290,
	"./get-to-know-gage-gallagher.json": 7292,
	"./sam-hill.json": 8130,
	"./sam-kannall-eager-to-give-back.json": 5587
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 878;